import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Simulation } from '../../../../shared/modules/evc-api/models/simulation';
import { NotificationType } from '../../../../shared/IFE/components/notification/notification.component';
import { SwiperOptions } from 'swiper/types';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from '../../../../shared/modules/analytics/services/analytics.service';
import { ActivatedRoute } from '@angular/router';
import { RouteName, routeMap } from 'src/app/app.settings';
import { swiperDefaultConfig } from '@app/shared/directives/swiper.directive';

@Component({
  selector: 'app-personal-calculation',
  templateUrl: './personal-calculation.component.html',
  styleUrls: ['./personal-calculation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalCalculationComponent implements OnInit {
  @Input() simulation: Simulation;
  readonly notificationType = NotificationType;

  queryParams = '';
  quoteUrl = '';
  slidesIterator = Array.from({ length: 4 }, (_, i) => i + 1);
  swiperConfig: SwiperOptions = {
    ...swiperDefaultConfig,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: this.slidesIterator.length,
        spaceBetween: 0,
      },
    },
  };

  private standalone = true;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    const simuRegex = routeMap.find((el) => el.name === RouteName.simulator).regex;
    this.standalone = !simuRegex.test(window.location.pathname);

    // Add the simId to the url.
    const params = { ...this.route.snapshot.queryParams, ...{ simId: this.simulation.id } };

    Object.entries(params).forEach(([key, value]) => {
      this.queryParams += `${key}=${value}&`;
    });
    window.history.pushState({}, '', `${window.location.pathname}?${this.queryParams}`);
    this.analytics();
  }

  getQuoteUrl() {
    return this.standalone
      ? `/${this.translate.currentLang}/evc-quote` + window.location.search
      : routeMap.find((el) => el.name === RouteName.quote).basePath[this.translate.currentLang] +
          window.location.search;
  }

  private analytics() {
    this.analyticsService.push({
      event: 'evSimulator-Result',
      page: {
        step: 'evcSimulator.personal-calculation',
        simulationConversion: 1,
        evcSimulator: {
          simId: this.simulation.id,
          simulationResult: this.simulation.discountedPrice,
          houseInfo: {
            houseType: this.simulation.houseType,
          },
          chargingStationPlacement: this.simulation.placement,
          chargingStationDistance: this.simulation.distance,
          electricPhase: this.simulation.phase,
        },
      },
    });
  }
}
